<script>
export default {
  name: 'ChannelSectionTitle'
}
</script>

<template>
  <h3 class="c-section-title"><slot /></h3>
</template>

<style scoped lang="scss">
@import '@/assets/style/colors';
@import '@/assets/style/vars';

.c-section-title {
  font-family: $fontCorpo;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 23px;
  text-align: center;
  color: $nearBlack;
  max-width: $maxWidthXl;
  text-wrap: balance;
  margin: 0 auto;
}
</style>
